import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { getDataAttributes } from '../../../../../../util/getDataAttributes/getDataAttributes.js';
import { Box } from '../../../../../Box/Box.js';
import { Track as TrackMemoized } from '../../../../Track/Track.js';

var TrackContainer = Box;
var StepContainer = Box;
var MarkerAndTrackContainer = Box;
var HorizontalStep = function HorizontalStep(props) {
  var endSlot = props.endSlot,
    startSlot = props.startSlot,
    isLastStep = props.isLastStep,
    stepContainerProps = props.stepContainerProps,
    markerAndTrackContainerProps = props.markerAndTrackContainerProps,
    trackContainerProps = props.trackContainerProps,
    trackProps = props.trackProps,
    marker = props.marker;
  var _getDataAttributes = getDataAttributes(props),
    dataAttributes = _getDataAttributes.dataAttributes;
  var track = !isLastStep && /*#__PURE__*/React.createElement(TrackContainer, trackContainerProps, /*#__PURE__*/React.createElement(TrackMemoized, trackProps));
  return /*#__PURE__*/React.createElement(StepContainer, _extends({}, stepContainerProps, dataAttributes), startSlot, /*#__PURE__*/React.createElement(MarkerAndTrackContainer, markerAndTrackContainerProps, marker, track), endSlot);
};
var HorizontalStepMemoized = /*#__PURE__*/React.memo(HorizontalStep);

export { HorizontalStep as BaseHorizontalStep, HorizontalStepMemoized as HorizontalStep };
//# sourceMappingURL=HorizontalStep.js.map
